import { Calendar, Users, UserPlus, FileText, FolderOpen, AlertTriangle } from 'lucide-react'
import { motion } from 'framer-motion'
import Card from '../ui/Card'
import Button from '../ui/Button'

const FeaturesSection = () => {
  const features = [
    {
      icon: Calendar,
      title: 'Férias e Folgas',
      description: 'Gerencie férias, folgas e afastamentos de forma automatizada com controle total sobre períodos e aprovações.',
      color: 'text-blue-600 bg-blue-100 dark:bg-blue-900/30'
    },
    {
      icon: Users,
      title: 'Escala de Trabalho',
      description: 'Crie e gerencie escalas de trabalho personalizadas para diferentes turnos e departamentos.',
      color: 'text-purple-600 bg-purple-100 dark:bg-purple-900/30'
    },
    {
      icon: UserPlus,
      title: 'Admissão Digital',
      description: 'Processo de admissão 100% digital com assinatura eletrônica e gestão completa de documentos.',
      color: 'text-green-600 bg-green-100 dark:bg-green-900/30'
    },
    {
      icon: FileText,
      title: 'Holerite Online',
      description: 'Distribuição automática de holerites digitais com segurança e rastreabilidade de visualização.',
      color: 'text-orange-600 bg-orange-100 dark:bg-orange-900/30'
    },
    {
      icon: FolderOpen,
      title: 'GED (Gestão de Documentos)',
      description: 'Armazene e gerencie todos os documentos dos colaboradores de forma segura e organizada.',
      color: 'text-cyan-600 bg-cyan-100 dark:bg-cyan-900/30'
    },
    {
      icon: AlertTriangle,
      title: 'Painel de Risco',
      description: 'Monitore riscos trabalhistas e mantenha sua empresa em conformidade com a legislação.',
      color: 'text-red-600 bg-red-100 dark:bg-red-900/30'
    }
  ]

  const scrollToContact = () => {
    document.getElementById('contato')?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <section id="funcionalidades" className="py-20 bg-gray-50 dark:bg-gray-950">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="inline-block px-4 py-2 rounded-full bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300 text-sm font-semibold mb-4">
            Funcionalidades
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white mb-4">
            Uma Plataforma Completa de{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-primary-800">
              RH Digital
            </span>
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Muito além do controle de ponto. O Flow Clock oferece um ecossistema completo 
            para gestão de recursos humanos na sua empresa.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {features.map((feature, index) => {
            const Icon = feature.icon
            return (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Card className="p-6 h-full hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group text-center">
                  <div className={`w-14 h-14 rounded-lg ${feature.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform mx-auto`}>
                    <Icon className="w-7 h-7" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
                    {feature.description}
                  </p>
                </Card>
              </motion.div>
            )
          })}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center space-y-4"
        >
          <p className="text-xl text-gray-600 dark:text-gray-300">
            Quer saber mais sobre como essas funcionalidades podem transformar seu RH?
          </p>
          <Button size="lg" onClick={scrollToContact}>
            Falar com Especialista
          </Button>
        </motion.div>
      </div>
    </section>
  )
}

export default FeaturesSection
